// services/GradeCorrectionRequestService.js
import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";

// Pas de mise à jour/suppression directe : le cycle de vie passe uniquement
// par create -> approve (x2, double validation) / reject.
export function getGradeCorrectionRequests(params = {}) {
    return api.get(ENDPOINTS.GRADE_CORRECTION_REQUESTS.BASE, { params });
}
export function getGradeCorrectionRequestById(id) {
    return api.get(ENDPOINTS.GRADE_CORRECTION_REQUESTS.BY_ID(id));
}
export function createGradeCorrectionRequest(payload) {
    return api.post(ENDPOINTS.GRADE_CORRECTION_REQUESTS.BASE, payload);
}
export function approveGradeCorrectionRequest(id) {
    return api.post(ENDPOINTS.GRADE_CORRECTION_REQUESTS.APPROVE(id));
}
export function rejectGradeCorrectionRequest(id) {
    return api.post(ENDPOINTS.GRADE_CORRECTION_REQUESTS.REJECT(id));
}
